import {clearDeepLinkUrl} from './deep-linking/deep-linking.util';
import {Logger} from './splunk/logger.util';
import {getUserName} from './user.util';

export const redirectToLogin = async (
  injectedStore?: {
    store: any;
    dispatch: any;
  },
  injectedLogout?: (
    dispatch: any,
    dispatchMe: any,
    username: string,
  ) => Promise<void>,
) => {
  try {
    clearDeepLinkUrl();

    const store = injectedStore
      ? injectedStore.store
      : // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        (await import('../redux/store/create')).store;

    const {handleLogoutCleanup} = injectedLogout
      ? {handleLogoutCleanup: injectedLogout}
      : // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        await import('../redux/action/auth.action');

    const dispatch = store.dispatch;
    const userName = await getUserName();
    const dispatchMe = () => Promise.resolve();

    await handleLogoutCleanup(dispatch, dispatchMe, userName ?? '');
  } catch (error) {
    Logger.manualSplunkLog({
      loginType: 'Token_Expired',
      message: `Called Logout when Token error ${error}`,
      severity: 'LOW',
    });
    return error;
  }
};
